import axios from 'axios';
import { useState, useEffect } from 'react';
import { getColumnLength } from '../../helpers/utils';
import useConfirm from '../../../../components/common/useConfirm';

const workerType = {
  staff: 'staff',
  contractual: 'contractual',
  operator: 'operator',
};

const useGetData = (
  annual_date: string | null | undefined,
  created_date: string | null | undefined,
  department_id: string | null | undefined
) => {
  const [moduleData, setModuleData] = useState<any>({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSync, setIsSync] = useState(false);
  const [DialogSync, confirmSync] = useConfirm(
    'Sync New Parts',
    'Are you sure you want to Sync ? Make sure to save any changes before syncing!'
  );

  const handelSync = async () => {
    const ans = await confirmSync();
    if (!ans) return;
    axios
      .get(`/api/annualLeaves/syncPart/${moduleData._id}/${created_date}`)
      .then((res) => {
        window.alert(
          'successfully sync dont forget to save the document after sync'
        );
        const data = res.data.result;
        setModuleData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setIsLoading(true);
    const handleApi = async () => {
      try {
        const response = await axios.get(`/api/annualLeaves/${created_date}`);
        const prevData: any = await axios.get(
          `/api/annualLeaves/getPrevYear/${created_date}`
        );
        response.data.success && setModuleData(response.data.result);

        const getPrevBal = (empId: any) => {
          const data = prevData.data.result?.list?.filter(
            (data: any) => data.emp_id === empId
          );
          if (data?.length) {
            return data[0].balance;
          }
          return null;
        };

        if (!response.data?.result?._id) {
          axios
            .get(`/api/annualLeaves/getAllEmp`)
            .then((res) => {
              const response = res.data;
              setModuleData((_: any) => ({
                month_year: annual_date,
                created_date: created_date,
                list: response?.map((item: any, index: number) => ({
                  emp_id: item,
                  prev_blank: getPrevBal(item._id),
                  blank: getPrevBal(item._id),
                  month_arr: Array(12).fill(null),
                })),
              }));
            })
            .catch((err) => {
              setIsLoading(false);
              setError(err);
            });
        }
      } catch (err: any) {
        setIsLoading(false);
        setError(err);
      }
    };

    handleApi();
  }, [isSync]);

  return {
    moduleData,
    setIsSync,
    isLoading,
    handelSync,
    DialogSync,
    error,
  };
};

export default useGetData;
